import React from 'react';
import { Link } from 'react-router-dom';

export const Hero = () => (
  <div className="wrap">
    <section className="hero" style={{ marginTop: 0 }}>
      <p className="eyebrow">Web · Mobile · AI — Serving NYC &amp; Northern NJ</p>
      <h1>We build the website, the app, and the AI behind it.</h1>
      <p className="lede">
        HMTechz is a small studio that designs and ships custom software for
        businesses that want senior work without agency overhead. Fixed prices,
        plain English, and you own every line of code.
      </p>
      <div className="hero-actions">
        <Link to="/pricing" className="btn solid">See the rate card</Link>
        <Link to="/#contact" className="btn">Start a project</Link>
      </div>
      <div className="hero-meta">
        <span>Fixed-fee projects</span>
        <span>You own the code</span>
        <span>30 days of free fixes after launch</span>
      </div>
    </section>
  </div>
);
